
const fieldConditionHelper =  {
    employment: (app) => {
        let shouldHide = false;
        let validEmploymentStatuses = ["full_time","part_time","self_employed","gig_worker"];
        if( app.income_type && !validEmploymentStatuses.includes(app.income_type) ) {
            shouldHide = true;
        }
        return shouldHide;
    },
    isSelfEmployment: (app) => {
        let shouldHide = false;
        let validEmploymentStatuses = ["self_employed","gig_worker"];
        if( !app.income_type || validEmploymentStatuses.includes(app.income_type) ) {
            shouldHide = true;
        }
        return shouldHide;
    },
    homeOwner: (app) => {
        let shouldHide = false;
        if( !app.own_home || app.own_home == "no" ) {
            shouldHide = true;
        }
        return shouldHide;
    },
    accountCreation: (app) => {
        let shouldHide = false;
        if( !app.wants_to_create_account || app.wants_to_create_account != "yes" ) {
            shouldHide = true;
        }
        return shouldHide;
    },
    retryLogin: (app) => {
        let shouldHide = false;
        if( !app.wrong_password_decision || app.wrong_password_decision != "retry_login" ) {
            shouldHide = true;
        }
        return shouldHide;
    },
    resetPassword: (app) => {
        let shouldHide = false;
        if( (!!app.wants_to_reset_password && app.wants_to_reset_password != "yes") ||
            (!!app.wrong_password_decision && app.wrong_password_decision != "reset_password") ) {
            shouldHide = true;
        }
        return shouldHide;
    },
    hasAuthConsent: (app) => {
        let validOptions = ["1","2"];
        if( !!app.credit_auth && validOptions.includes(app.credit_auth) ) {
            return true;
        }
        return false;
    },
    meetsSkcpConditions: (app) => {
        let shouldHide = true;
        var allowedProvinces = ["AB","BC","MB","NB","NL","ON","PE","SK","NT","NU","YK"];
        var allowedIncomeType = ['full_time','retired'];
        var allowedCreditSituations = ['good','fair','unknown'];

        if( app.direct_deposit &&
            app.address && app.address.province &&
            app.income_type &&
            app.monthly_income &&
            app.direct_deposit == 'yes' &&
            app.monthly_income >= 1500 &&
            allowedProvinces.includes(app.address.province) &&
            allowedIncomeType.includes(app.income_type) &&
            // we removed credit score question for now
            // app.credit_score && app.credit_score != 'low' &&
            // app.in_credit_situation && app.in_credit_situation == 'none' &&
            app.in_credit_situation && allowedCreditSituations.includes(app.in_credit_situation) &&
            app.completed_flinks && app.completed_flinks == 'yes') {
                shouldHide = false;
            }
        return shouldHide;
    }
}

export { fieldConditionHelper }
